module.exports = {"id":"dp2_2l1q5","text":"Sharing Through Digital Technologies","instructions":"Which of the following best describes how AI systems can share content?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.2","questionType":"PickOne","random":true,"options":[{"id":"dp2_2l1q5-a1","text":"AI systems can automatically generate and distribute content","score":1.8},{"id":"dp2_2l1q5-a2","text":"AI systems can only store information","score":0},{"id":"dp2_2l1q5-a3","text":"AI systems cannot share content","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.2/l1q5.json
// module id = 1014
// module chunks = 41